export default __webpack_public_path__ + "static/media/date-image.6d427760.png";